module.exports = __webpack_public_path__ + "media/images/socials/snapchat-9fa90b6181409af24f14c372070cbcac.png";